import { __decorate } from "tslib";
import { Component } from "vue-property-decorator";
import { mixins } from "vue-class-component";
import commonNewMixins from "@/mixins/commonNewMixins";
let ts = class ts extends mixins(commonNewMixins) {};
ts = __decorate([Component({
  name: "ts",
  components: {}
})], ts);
export default ts;